import { useQuery } from "@tanstack/react-query";
import {
  fetchTestimonial,
  fetchTestimonialById,
  getSocialProofAssetById,
  getSocialProofAssets,
} from "./endpoints";
import {
  SocialProofAsset,
  SocialProofAssetQuery,
  TestimonialQuery,
} from "./types";

export const useFetchTestimonials = (filters: TestimonialQuery) => {
  return useQuery({
    queryFn: () => fetchTestimonial(filters),
    queryKey: ["testimonials", filters],
  });
};

export const useFetchTestimonialById = (id: string) => {
  return useQuery({
    queryFn: () => fetchTestimonialById(id),
    queryKey: ["testimonials", id],
  });
};

export const useGetSocialProofAssets = (query: SocialProofAssetQuery) => {
  return useQuery({
    queryFn: () => getSocialProofAssets(query),
    queryKey: ["social-proof", ...Object.keys(query)],
  });
};

export function useGetSocialProofAssetById<T>({
  id,
  refId,
}: {
  id?: string;
  refId?: string;
}): ReturnType<typeof useQuery<SocialProofAsset<T>>> {
  return useQuery({
    queryFn: () => getSocialProofAssetById<T>({ id, refId }),
    queryKey: ["social-proof", id],
  });
}
